module.exports = __webpack_public_path__ + "img/products1.9cda4f44.jpg";